import { render, staticRenderFns } from "./FormTemplateDateQuestion.vue?vue&type=template&id=2171957f&scoped=true&"
import script from "./FormTemplateDateQuestion.vue?vue&type=script&lang=js&"
export * from "./FormTemplateDateQuestion.vue?vue&type=script&lang=js&"
import style0 from "./FormTemplateDateQuestion.vue?vue&type=style&index=0&id=2171957f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2171957f",
  null
  
)

export default component.exports